import React, {ReactNode} from "react";

export function Main({children}: {children: ReactNode}) {
    return (
        <main className={'flex flex-col gap-8 rounded-2xl py-8 max-w-[871px] mx-auto mt-8 mb-[100px]'}>
            {children}
        </main>
    )
}
